import { Pipe, PipeTransform } from '@angular/core';

import { tiposPrecificacoes } from '../item/tabela-preco-item-tipo-precificacao';

@Pipe({
    name: 'tabelaPrecoItemTipoPrecificacaoAbreviacao'
})
export class TabelaPrecoItemTipoPrecificacaoAbreviacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = tiposPrecificacoes.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return tiposPrecificacoes[index].abreviacao;
        }
        return '';
    }
}
